export default {
  doesIncludeSetpoints: 'Show every setpoint with its tolerances',
  doesIncludeSignalLegend: 'List the digital outputs and conditions below the steps',
};
